import Cliente from "entity/Cliente"
import Fazenda from "entity/Fazenda"

const saving = (fazenda, fazendaCarregando, totalFazendas) => {
    let entity = new Fazenda()
    entity.update(fazenda)
    entity.save().then(() => {
        console.log(`${fazendaCarregando}/${totalFazendas} salvou a fazenda ${fazenda.nomeFazenda}`)
    })
}

function iterateWithDelay(index, array, setLoadingCSV, change) {
    return new Promise(resolve => {
        setTimeout(() => {
            defineFields(array[index], change)
            setLoadingCSV(((index + 1) / array.length * 100).toFixed(0))
            saving(array[index], (index + 1), array.length)
            resolve()
        }, 3000)
    })
}

const defineFields = (result, change) => {
    change("areaTotalFazenda", result && result.areaTotalFazenda ? result.areaTotalFazenda : '')
    change("cidadeFazenda", result && result.cidadeFazenda ? result.cidadeFazenda : '')
    change("cliente", result && result.cliente ? result.cliente : '')
    change("codFazenda", result && result.codFazenda ? result.codFazenda : '')
    change("enderecoFazenda", result && result.enderecoFazenda ? result.enderecoFazenda : '')
    change("estadoFazenda", result && result.estadoFazenda ? result.estadoFazenda : '')
    change("nomeFazenda", result && result.nomeFazenda ? result.nomeFazenda : '')
    change("status", result && result.status ? result.status : '')
    change("talhoesFazenda", result && result.talhoesFazenda ? result.talhoesFazenda : [])
}

const csvToObject = (data, result, cliente, contents) => {
    const lines = contents.split('\n')
    const headerText = ['COD FAZENDA', 'FAZENDA', 'TALHÃO', 'VARIEDADE ANTERIOR', 'MATURAÇÃO', 'PROPRIETARIO', 'AMBIENTE', 'ÁREA', 'RAIO', 'DIA PLANTO', 'ORIGEM MUDA', 'TALHÃO MUDA', 'PLANTIO MUDA', 'IDADE MUDA', 'VARIEDADE PLANTIO', 'ÁREA 02', 'RAIO MUDA', 'PRESTADOR', 'NUMERO MÊS', 'MÊS', 'TIPO PLANTIO', 'INICIO', 'DIAS', 'FINAL']
    const headerIndex = findIndexContainingString(lines, headerText) // encontra a linha do header
    const headers = lines[headerIndex].split(',')

    // transforma cada linha em um objeto
    for (let i = headerIndex + 1; i < lines.length; i++) {
        const values = lines[i].split(',')
        if (values.length === headers.length) {
            const obj = {}
            for (let j = 0; j < headers.length; j++) {
                obj[headers[j].trim()] = values[j].trim()
            }
            data.push(obj)
        }
    }

    // transforma os objetos em objetos Fazenda
    data.forEach(fazenda => {
        let index = result.findIndex(r => fazenda['COD FAZENDA'] === r.codFazenda)

        if (index === -1) { // fazenda ainda não transformada em objeto Fazenda
            result.push({
                areaTotalFazenda: fazenda["ÁREA"],
                cidadeFazenda: ".",
                cliente: cliente.data,
                codFazenda: fazenda['COD FAZENDA'],
                enderecoFazenda: ".",
                estadoFazenda: "SP",
                nomeFazenda: fazenda['FAZENDA'],
                // sequencialIndex
                status: "ATIVO",
                talhoesFazenda: [
                    {
                        area: fazenda["ÁREA"],
                        nome: fazenda["TALHÃO"]
                    }
                ],
                // uid
                // userLastChange
            })
        } else { // atualiza fazenda (cada linha do csv é um talhão, fazenda com mais de um talhão ocorrem em mais de uma linha)
            let areaTotalResult = 0

            // atualiza talhoes
            result[index].talhoesFazenda.push({
                area: fazenda["ÁREA"],
                nome: fazenda["TALHÃO"]
            })

            // atualiza area total da fazenda
            if (result[index].talhoesFazenda && result[index].talhoesFazenda.length) {
                for (let i = 0; i < result[index].talhoesFazenda.length; i++) {
                    if (result[index].talhoesFazenda[i].area.trim().length > 0) {
                        areaTotalResult = areaTotalResult + parseFloat(result[index].talhoesFazenda[i].area)
                    }
                }
            }

            result[index].areaTotalFazenda = areaTotalResult
        }
    })
}

const findIndexContainingString = (array, targetStrings) => {
    for (let i = 0; i < array.length; i++) {
        for (const targetString of targetStrings) {
            if (array[i].toLowerCase().includes(targetString.toLowerCase())) {
                return i
            }
        }
    }
    return 0
}

const CSVReader = async (change, setLoadingCSV, navigate, showSuccess) => {
    const fileInput = document.createElement('input')
    fileInput.type = 'file'
    fileInput.accept = '.csv'
    const cliente = await Cliente.get("XWKnL5IkdsWFcXmoKges")

    fileInput.onchange = (event) => {
        const file = event.target.files[0]
        const reader = new FileReader()

        reader.onload = async (e) => {
            const contents = e.target.result
            const data = []
            let result = []

            // transformar csv em um objeto javascript Fazenda
            csvToObject(data, result, cliente, contents)

            for (let i = 0; i < result.length; i++) {
                // setando campos e salvando fazendas
                await iterateWithDelay(i, result, setLoadingCSV, change)
            }

            showSuccess('Salvo com sucesso')
            defineFields(null, change)
            setLoadingCSV(-1)
            navigate("/_fazenda")
        }
        reader.readAsText(file)
    }
    fileInput.click()
}

const configImport = { nome: "(BETA) Importar Fazendas - RAA", importFile: CSVReader }
export default configImport
